module.exports = __webpack_public_path__ + "img/plan4_book04.34b33c6e.png";